import type { ViewComponent } from "@frui.ts/views";
import { observer } from "mobx-react-lite";
import React from "react";
import { Col, Form } from "react-bootstrap";
import { emptyValue } from "utils/emptyValue";
import { formatDateTime } from "utils/localizations";
import type VehicleSynchronizationViewModel from "viewModels/callCenter/search/vehicleRegister/vehicleSynchronization/vehicleSynchronizationViewModel";

export const VehicleSynchronizationFistStepView: ViewComponent<VehicleSynchronizationViewModel> = observer(({ vm }) => {
  return (
    <div className="bg-light mb-6 px-4 pt-2 rounded">
      <Form.Row>
        <Form.Group as={Col} xs={6}>
          <Form.Label>{vm.translate("countryId")}</Form.Label>
          <div>{vm.formatCountry(vm.vehicleRegister?.countryId)}</div>
        </Form.Group>
        <Form.Group as={Col} xs={6}>
          <Form.Label>{vm.translate("licensePlate")}</Form.Label>
          <div>{vm.vehicleRegister?.licensePlate}</div>
        </Form.Group>
        <Form.Group as={Col} xs={6}>
          <Form.Label>{vm.translate("vin")}</Form.Label>
          <div>{vm.vehicleRegister?.vin}</div>
        </Form.Group>
        <Form.Group as={Col} xs={6}>
          <Form.Label>{vm.translate("updatedAt")}</Form.Label>
          <div>{vm.updatedAt ? formatDateTime(new Date(vm.updatedAt)) : emptyValue}</div>
        </Form.Group>
      </Form.Row>
    </div>
  );
});

export default VehicleSynchronizationFistStepView;
